import { AsmUsageType } from '../models/asm-usage-type';
import { SolType, SolViewId, TypeService, ViewService } from '@sol/components';
import { AsmLicenseUsageTools, LicenseUsageBudget } from '../tools/asm-license-usage-tools';

export function provideAsmUsageViews(viewService: ViewService, typeService: TypeService): void {
  typeService.addType(AsmUsageType.licenseUsageBudget);
  viewService.deriveView(SolType.string.array, 'read', AsmUsageType.licenseUsageBudget, SolViewId.textField, {
    isDefault: true,
    mapValue: (budget: LicenseUsageBudget) => [AsmLicenseUsageTools.formatBudget(budget)],
  });
}
